(() => {
  const currentCountry = window.Shopify?.country
  const marketRoot = window.Shopify?.routes?.root
  const manualMarketStorageKey = 'mc-manual-market'
  const linkedCountry = new URLSearchParams(window.location.search).get('mc_country')?.toUpperCase()

  // Email deep links carry this marker because Shopify can consume ?country before
  // this script runs. Honor the country Shopify selected, just like a manual choice.
  if (linkedCountry && /^[A-Z]{2}$/.test(linkedCountry) && linkedCountry === currentCountry) {
    try {
      window.sessionStorage.setItem(manualMarketStorageKey, linkedCountry)
    } catch {}
    return
  }

  const hasManualMarketSelection = () => {
    try {
      return window.sessionStorage.getItem(manualMarketStorageKey) !== null
    } catch {
      return false
    }
  }

  if (!currentCountry || !marketRoot || hasManualMarketSelection()) return

  const suggestionsUrl = new URL(
    `${marketRoot}browsing_context_suggestions.json`,
    window.location.origin
  )

  suggestionsUrl.searchParams.set('country[enabled]', 'true')
  suggestionsUrl.searchParams.set('country[exclude]', currentCountry)

  fetch(suggestionsUrl, { credentials: 'same-origin' })
    .then(response => (response.ok ? response.json() : null))
    .then(data => {
      if (hasManualMarketSelection()) return

      const suggestion = data?.suggestions?.[0]
      const country = suggestion?.parts?.country

      if (
        !country?.handle ||
        country.handle === currentCountry ||
        suggestion.confidence !== 1 ||
        country.confidence !== 1
      ) {
        return
      }

      const form = document.createElement('form')
      const localizationUrl = new URL('localization', suggestionsUrl)
      const fields = {
        _method: 'put',
        country_code: country.handle,
        return_to: `${window.location.pathname}${window.location.search}${window.location.hash}`
      }

      form.action = localizationUrl.pathname
      form.hidden = true
      form.method = 'post'

      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input')
        input.name = name
        input.type = 'hidden'
        input.value = value
        form.append(input)
      })

      document.body.append(form)
      form.submit()
    })
    .catch(() => {})
})()
